"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  xs: 767,
  // > 768
  sm: 991,
  // >=768 && < 992
  md: 1199,
  // >=992 && < 1200
  lg: 1600 // >=1200 && <1600

};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/maps/breakpoints.js
// module id = 4405
// module chunks = 25